﻿'use strict';

/**
 * @ngdoc directive
 * @name ntmApp.directive:homeTileContent
 * @description
 * # homeTileContent
 */
angular.module('ntmApp')
  .directive('calendarControl', [function () {
      return {
          restrict: 'E',
          templateUrl: 'ng1/src/calendar/templates/calendar-control.html',
          scope: {
              calendar: '='
          },
          link: function (scope) {
              scope.calendar.LoadConfig();
          }
      };
  }]);